module.exports = __webpack_public_path__ + "media/icons/business-checklist-5e11d1e2.png";